var _path, _g, _g2, _g3, _g4, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7791 35H7.22091C3.23127 35 0 32.1111 0 28.5507V6.4493C0 2.88598 3.23457 0 7.22091 0H27.7791C31.7687 0 35 2.88893 35 6.4493V28.5507C35.0033 32.1111 31.7687 35 27.7791 35Z",
    fill: "url(#paint0_linear_26080_12435)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_26080_12435)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 13.502,
    width: 25,
    height: 3,
    rx: 1.5,
    fill: "white",
    fillOpacity: 0.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_26080_12435)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 19.499,
    width: 25,
    height: 3,
    rx: 1.5,
    fill: "white",
    fillOpacity: 0.25
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_26080_12435)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7.5,
    width: 25,
    height: 3,
    rx: 1.5,
    fill: "white",
    fillOpacity: 0.25
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_26080_12435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.75 40C22.5366 40 17.5 34.9634 17.5 28.75C17.5 22.5366 22.5366 17.5 28.75 17.5C34.9634 17.5 40 22.5366 40 28.75C40 34.9634 34.9634 40 28.75 40Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7935 27.4465L26.7073 24.8571C27.9444 23.1833 28.5629 22.3464 29.1401 22.5233C29.7171 22.7001 29.7171 23.7266 29.7171 25.7794V25.973C29.7171 26.7134 29.7171 27.0837 29.9537 27.3159L29.9662 27.3279C30.2079 27.5552 30.5932 27.5552 31.3639 27.5552C32.7507 27.5552 33.4441 27.5552 33.6784 27.9758C33.6823 27.9827 33.6861 27.9898 33.6897 27.9969C33.911 28.424 33.5095 28.9672 32.7065 30.0536L30.7927 32.6429C29.5556 34.3167 28.937 35.1536 28.3599 34.9767C27.7828 34.7999 27.7828 33.7734 27.7828 31.7205L27.7829 31.5271C27.7829 30.7866 27.7829 30.4164 27.5462 30.1841L27.5337 30.1721C27.2921 29.9448 26.9067 29.9448 26.1361 29.9448C24.7493 29.9448 24.0559 29.9448 23.8216 29.5242C23.8177 29.5172 23.8139 29.5102 23.8102 29.5031C23.589 29.0761 23.9905 28.5329 24.7935 27.4465Z",
    fill: "url(#paint1_linear_26080_12435)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_26080_12435",
    x: -3.81461,
    y: 4.68735,
    width: 42.6292,
    height: 20.6292,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.4073
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26080_12435"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26080_12435",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_26080_12435",
    x: -3.81461,
    y: 10.6844,
    width: 42.6292,
    height: 20.6292,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.4073
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26080_12435"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26080_12435",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_26080_12435",
    x: -3.81461,
    y: -1.31461,
    width: 42.6292,
    height: 20.6292,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.4073
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26080_12435"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26080_12435",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_26080_12435",
    x: 5.95272,
    y: 5.95272,
    width: 45.5946,
    height: 45.5946,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.77364
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26080_12435"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26080_12435",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26080_12435",
    x1: -0.729166,
    y1: -4.19271,
    x2: 34.8177,
    y2: 35.5469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86DCF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746EF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26080_12435",
    x1: 23.75,
    y1: 23.4766,
    x2: 35.1306,
    y2: 31.7352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectContent);
export default __webpack_public_path__ + "static/media/select-content.8d4edbcbd8171d786c794bc9249d3e78.svg";
export { ForwardRef as ReactComponent };